<div class="searchBarPopularDestinations__cont" *ngIf="activePopularDestinations">
  <app-ds-typography
    [tag]="'h3'"
    [size]="fontSize.XXS"
    [fontFamily]="fontFamily.SemiBold"
    [color]="fontColor.Primary"
    [text]="'SEARCH_MODULE.TITLE_POPULAR_DESTINATIONS' | transloco">
  </app-ds-typography>
  <div class="searchBarPopularDestinations__item" *ngFor="let destination of destinations" (click)="selectDestination(destination)">
    <div class="searchBarPopularDestinations__item-info">
      <div class="searchBarPopularDestinations__item-info-image">
        <app-ds-image
          [size]="imageSize"
          [height]="'48px'"
          [width]="'48px'"
          [objectFit]="'cover'"
          [borderRadius]="imageBorderRadius"
          [useLoader]="true"
          [src]="imageDestination(destination)">
        </app-ds-image>
      </div>
      <app-ds-typography
        [size]="fontSize.XXS"
        [color]="fontColor.Primary"
        [text]="destination| placeName | async"
        [ellipsis]="true">
      </app-ds-typography>
    </div>
    <div class="searchBarPopularDestinations__item-code">
      <app-ds-typography
        [size]="fontSize.XS"
        [color]="fontColor.Primary"
        [text]="destination">
      </app-ds-typography>
    </div>
  </div>
</div>